import i18next from 'i18next';
import { ModifiedArray } from 'infrastructure/classes/common/modified-array';
import { HoldingStatus } from 'infrastructure/enums';

export interface IHoldingStatusItem {
  id: HoldingStatus;
  name: string;
}

type HoldingStatusesArray = ModifiedArray<IHoldingStatusItem>;

export const holdingStatusesDataSource = (): HoldingStatusesArray => {
  return new ModifiedArray<IHoldingStatusItem>(
    {
      id: HoldingStatus.Active,
      name: i18next.t('holdingStatuses.active'),
    },
    {
      id: HoldingStatus.Hospital,
      name: i18next.t('holdingStatuses.hospital'),
    },
    {
      id: HoldingStatus.Vacation,
      name: i18next.t('holdingStatuses.vacation'),
    },
  );
};
